import { Button, ButtonProps } from "@mui/material";

interface CustomButtonProps extends ButtonProps {
  buttonText: string;
  iconSrc?: string;
  iconSize?: number;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  buttonText,
  iconSrc,
  iconSize = 14,
  onClick,
  ...props
}) => {
  return (
    <Button
      variant="outlined"
      sx={{
        height: { xs: "28px", sm: "30px", md: "34px" },
        px: { xs: 1, sm: 2 },
        borderRadius: "8px",
        textTransform: "none",
        fontWeight: 700,
        fontSize: { xs: "10px", sm: "12px" },
        lineHeight: "16px",
        display: "flex",
        alignItems: "center",
        gap: { xs: 0.5, sm: 1 },
        minWidth: 0,
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
      onClick={onClick} // Button click handler
      {...props}
    >
      {buttonText}
      {iconSrc && <img src={iconSrc} alt="icon" width={iconSize} height={iconSize} />}
    </Button>
  );
};

export default CustomButton;
